
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/call-center",
      function () {
        return require("private-next-pages/call-center.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/call-center"])
      });
    }
  